import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api, { extrairMensagemErro } from '../services/api';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const tipo = useMemo(() => {
    const valor = (params.get('tipo') || 'usuario').toLowerCase();
    return valor === 'fornecedor' ? 'fornecedor' : 'usuario';
  }, [params]);
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [mensagem, setMensagem] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(false);

  const submeter = async (evento: React.FormEvent) => {
    evento.preventDefault();
    setErro(null);
    setMensagem(null);

    if (!token) {
      setErro('Token de recuperação ausente.');
      return;
    }

    if (novaSenha !== confirmacao) {
      setErro('A confirmação deve ser igual à nova senha.');
      return;
    }

    setCarregando(true);
    try {
      const resposta = await api.post('/auth/reset-password', {
        token,
        tipo,
        nova_senha: novaSenha
      });
      setMensagem(resposta.data.mensagem || 'Senha redefinida com sucesso.');
      setNovaSenha('');
      setConfirmacao('');
    } catch (erroReset: any) {
      setErro(extrairMensagemErro(erroReset, 'Não foi possível redefinir a senha.'));
    } finally {
      setCarregando(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="brand-lockup">
          <img className="brand-mark" src="/assets/logotipo-akzicao.png" alt="Akzição" />
          <div>
            <h1>Akzição</h1>
            <p>Redefinição segura de senha.</p>
          </div>
        </div>

        <form className="login-form" onSubmit={submeter}>
          <h2>Nova senha</h2>
          <span className="status-pill">{tipo === 'fornecedor' ? 'Fornecedor' : 'Equipa interna'}</span>
          <label>
            Nova senha
            <input type="password" minLength={8} value={novaSenha} onChange={(evento) => setNovaSenha(evento.target.value)} required />
          </label>
          <label>
            Confirmar senha
            <input type="password" minLength={8} value={confirmacao} onChange={(evento) => setConfirmacao(evento.target.value)} required />
          </label>

          {mensagem && <div className="alerta alerta-sucesso">{mensagem}</div>}
          {erro && <div className="alerta alerta-erro">{erro}</div>}

          <button className="botao botao-primario" type="submit" disabled={carregando}>
            {carregando ? 'A redefinir...' : 'Redefinir senha'}
          </button>
          <Link className="botao botao-secundario" to="/login">
            Voltar ao login
          </Link>
        </form>
      </section>
    </main>
  );
};

export default ResetPassword;
